import { AkeneoModel } from "./akeneoModels.models";
import { Package } from "./package.models";
import { PackageRow } from "./packageRow.models";
import { Product } from "./product.models";

export interface ModelAssociations {
  [key: string]: number;
}

export interface ProductAssociations {
  [key: string]: number;
}

export interface ParentModel {
  identifier: string;
  name: string;
  companyId: string;
  image: string;
  family: string;
  packageRowsAssociation: string;
  ean: string;
  modelReverseAssociations: { [key: string]: number };
  productAssociations: { [key: string]: number };
  modelAssociations: { [key: string]: number };
}

export interface Model {
  identifier: string;
  name: string;
  companyId: string;
  image: string;
  family: string;
  modelAssociations: ModelAssociations;
  ean: string;
  packageAssociation: string;
  productAssociations: ProductAssociations;
}

export interface FullProductData {
  product: Product;
  package: Package;
  packageRows: PackageRow;
  parentModels: ParentModel[];
}

export enum Family {
  product = "product",
  product_model = "product_model",
  package_rows = "package_rows",
  package = "package",
}
